module.exports = "/static/assets/e674c9093c89319075eb0a3aabea06ae.png";